import React /*, { useMemo }*/ from 'react';
import { NavLink } from 'react-router-dom';
import useWindowDimensions from '../../../helpers/useWindowDimensions';

export const RequestIdTableCell = ({ row, url, idRoute }) => {
    const { width } = useWindowDimensions();
    return width < 989 ? (
        <NavLink
            to={
                url ||
                `process/${row.original?.persona?.numero_identificacion}/${row.original.pk}/${row.original?.persona.pk}`
            }
            className="finamiga-color">
            <div
                style={{
                    width: '100%',
                    textAlign: 'center',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    border: '1px solid var(--var-color-semi-white)',
                    padding: '.5rem',
                    borderRadius: '0.42rem',
                    marginBottom: '1rem',
                    cursor: 'pointer',
                    paddingTop: '.7rem',
                }}>
                {row.original?.alerta_informativa ? (
                    <span
                        className={`box-state ${row.original?.alerta_informativa?.color}`}
                        title={
                            row.original?.alerta_informativa?.texto
                                ? row.original?.alerta_informativa?.texto
                                : ''
                        }>
                        <i
                            className={`${row.original?.alerta_informativa?.icono} mr-2 font-weight-bold`}
                            style={{ fontSize: '.9rem' }}
                        />
                        {idRoute || row.original.pk}
                    </span>
                ) : (
                    <span className="font-weight-bold ml-2">
                        #{idRoute || row.original.pk}
                    </span>
                )}

                <i
                    className="simple-icon-arrow-right mr-2"
                    style={{
                        color: 'var(--var-color-orange-primary)',
                        fontWeight: 'bold',
                    }}
                />
            </div>
        </NavLink>
    ) : (
        <NavLink
            to={
                url ||
                `process/${row.original?.persona.numero_identificacion}/${row.original.pk}/${row.original?.persona.pk}`
            }
            className="finamiga-color">
            {row.original?.alerta_informativa ? (
                <span
                    className={`box-state ${row.original?.alerta_informativa?.color}`}
                    title={
                        row.original?.alerta_informativa?.texto
                            ? row.original?.alerta_informativa?.texto
                            : ''
                    }>
                    <i
                        className={`${row.original?.alerta_informativa?.icono} mr-2 font-weight-bold`}
                        style={{ fontSize: '.9rem' }}
                    />
                    {idRoute || row.original.pk}
                </span>
            ) : (
                <span className="box-state">{idRoute || row.original.pk}</span>
            )}
        </NavLink>
    );
    // }
};
